import React from 'react';
import { IndexAvatar } from '../../../components';
import styles from "./userInfo.scss"

const UserInfo = ({ user }) => {
    return (
        <div className={styles.userInfo}>
            <IndexAvatar url={user.avatar} />
            <div className={styles.text}>
                <h3 className={styles.username}>{user.username}</h3>
                <p className={styles.email}>{user.email}</p>
            </div>
        
        </div >
    );
}

export default UserInfo;



// WEBPACK FOOTER //
// ./src/containers/SideMenu/UserInfo/index.tsx